import type { FormatterArgs } from '@/services/types/formatter';
import { isArchivedNameCell, resolveRowMark } from '@/views/formatters/row-mark';

export default ({ ctx, data, key }: FormatterArgs) => {
  if (!data[key]) return;

  if (!data.DT_RowCampaignExternalStatus) {
    return { kind: 'plain', text: String(data[key]) };
  }

  const inactiveTooltipText = data.DT_RowIntegrationStatus !== 'active'
    ? String(data.DT_RowIntegrationStatusMessage ?? '')
    : !ctx.$PL.integrationPropellerads
      ? ctx.t('The integration for this campaign is disabled. Purchase the addon from Subscription to restore it.')
      : undefined;

  return {
    kind: 'campaign-integration',
    name: String(data[key]),
    mark: resolveRowMark(data),
    archived: isArchivedNameCell(data, key),
    integrationActive: data.DT_RowIntegrationStatus === 'active',
    propellerAddonEnabled: !!ctx.$PL.integrationPropellerads,
    campaignActive: data.DT_RowStatus === 'active',
    inactiveTooltipText,
    activeTooltipText: ctx.t('This campaign is integrated via API with the corresponding traffic source.'),
    inactiveIntegrationTooltipText: ctx.t('The integration status for this campaign is inactive. Please check the settings.'),
  };
};
